@switch (field.attributes.display_type) { @case ('address') {
<address-control [field]="field"></address-control>
} @case ('multiField') {
<multi-field-control [field]="field"></multi-field-control>
} @case ('collectionType') {
<collection-type-field-control [field]="field"></collection-type-field-control>
} @case ('multiSelect') {
<multi-select-control [field]="field"></multi-select-control>
} @case ('text') {
<text-control [field]="field"></text-control>
} @case ('password') {
<password-control [field]="field"></password-control>
} @case ('number') {
<number-control [field]="field"></number-control>
} @case ('radio') {
<radio-control [field]="field"></radio-control>
} @case ('radiobar') {
<radiobar-control [field]="field"></radiobar-control>
} @case ('rating') {
<rating-control [field]="field"></rating-control>
} @case ('date') {
<date-control [field]="field"></date-control>
} @case ('multidate') {
<multi-date-control [field]="field"></multi-date-control>
} @case ('datetime') {
<datetime-control [field]="field"></datetime-control>
} @case ('full-datetime') {
<datetime-control [field]="field" [full]="true"></datetime-control>
} @case ('email') {
<email-control [field]="field"></email-control>
} @case ('select') {
<select-control [field]="field"></select-control>
} @case ('select2') {
<k2-select-control [field]="field"></k2-select-control>
} @case ('dropdownMultiple') {
<k2-select-control [field]="field" [multiple]="true"></k2-select-control>
} @case ('iconselect') {
<icon-select-control [field]="field"></icon-select-control>
} @case ('checkbox') {
<checkbox-control [field]="field"></checkbox-control>
} @case ('checkboxes') {
<checkboxes-control [field]="field"></checkboxes-control>
} @case ('recipients') {
<recipients-control [field]="field"></recipients-control>
} @case ('k2UsersSelector') {
<k2-users-selector-control [field]="field"></k2-users-selector-control>
} @case ('k2TeamUsersSelector') {
<k2-users-selector-control
  [field]="field"
  [onlyTeam]="true"
></k2-users-selector-control>
} @case ('k2LinksSelector') {
<k2-links-selector-control [field]="field"></k2-links-selector-control>
} @case ('partnersSelector') {
<partners-selector-control [field]="field"></partners-selector-control>
} @case ('partnerFinder') {
<partner-finder-control [field]="field"></partner-finder-control>
} @case ('partnerTransitServiceFinder') {
<partner-transit-service-finder
  [field]="field"
></partner-transit-service-finder>
} @case ('locationsSelector') {
<locations-selector-control [field]="field"></locations-selector-control>
} @case ('budget') {
<budget-control [field]="field"></budget-control>
} @case ('tel') {
<telephone-control [field]="field"></telephone-control>
} @case ('textarea') {
<textarea-control [field]="field"></textarea-control>
} @case ('markdown') {
<markdown-control [field]="field"></markdown-control>
} @case ('variations') {
<variations-control [field]="field"></variations-control>
} @case ('regions') {
<regions-control
  [field]="field"
  [changeServiceToUniversal]="changeServiceToUniversal"
></regions-control>
} @case ('clients') {
<clients-control [field]="field"></clients-control>
} @case ('yesno') {
<yes-no-control [field]="field"></yes-no-control>
} @case ('groupedCheckboxes') {
<grouped-checkboxes-control [field]="field"></grouped-checkboxes-control>
} @case ('workflowServiceVariations') {
<workflow-service-variations-control
  [field]="field"
></workflow-service-variations-control>
} @case ('documentsUploader') {
<documents-uploader-control [field]="field"></documents-uploader-control>
} @case ('quotedProduct') {
<quoted-product-control [field]="field"></quoted-product-control>
} @case ('contactCards') {
<contact-cards-control [field]="field"></contact-cards-control>
} @case ('airportSelector') {
<airport-selector-control [field]="field"></airport-selector-control>
} @case ('fileName') {
<text-control [field]="field" [deleteExtension]="true"></text-control>
} @case ('label') {
<span class="label-control-value">
  {{ field.control.value }}
</span>
} @case ('hidden') { } @default {
<empty class="warning">
  @if (field.attributes.display_type | isEmpty) {
  <span> Failed to render the field with no display type! </span>
  } @if (field.attributes.display_type | isNotEmpty) {
  <span>
    "{{ field.attributes.display_type }}" is an unknown display type!
  </span>
  }
</empty>
} }
